import { render, staticRenderFns } from "./LpCtaAction.vue?vue&type=template&id=33195d58&"
import script from "./LpCtaAction.vue?vue&type=script&lang=js&"
export * from "./LpCtaAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports